// En src/Config.js
const appSettingsUrl = './appsettings.json';

async function fetchAppSettings() {
  try {
    const response = await fetch(appSettingsUrl);
    if (!response.ok) {
      throw new Error('Error fetching appsettings.json');
    }

    const appSettings = await response.json();
    return appSettings;
  } catch (error) {
    console.error(error);
    return {};
  }
}

// Obtener la URL de appsettings.json o usar la variable de entorno si no está definida
const apiUrlFromAppSettings = async () => {
  const appSettings = await fetchAppSettings();
  return appSettings.apiUrl;
};

// Usa apiUrlFromAppSettings directamente o, si no está definido, usa la variable de entorno
export const API_URL = await apiUrlFromAppSettings() || process.env.REACT_APP_API_URL || 'https://fallback-api-url.com';

// Obtener la versión desde appsettings.json o usar la variable de entorno
const appVersionFromAppSettings = async () => {
  const appSettings = await fetchAppSettings();
  return appSettings.version;
};
export const getAppVersion = async () => {
  return await appVersionFromAppSettings() || process.env.REACT_APP_VERSION || 'No se pudo obtener versión';
};